import { render, staticRenderFns } from "./ConfiguracaoGeralModal.vue?vue&type=template&id=506ea084&scoped=true"
import script from "./ConfiguracaoGeralModal.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoGeralModal.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoGeralModal.vue?vue&type=style&index=0&id=506ea084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ea084",
  null
  
)

export default component.exports